export default "__VITE_ASSET__BjL3JZ0r__"